var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm.isSafari
        ? [_c("safari-Blocked")]
        : [
            _c("div", { staticClass: "container-fluid" }, [
              _c(
                "div",
                { staticClass: "flex" },
                [
                  _c("blinki-header", {
                    class: { "header-mini-menu": !_vm.fullMenu },
                  }),
                  _vm._v(" "),
                  _vm.menuShow
                    ? _c("sidebar", { attrs: { full: _vm.fullMenu } })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "main",
                    {
                      staticClass: "col-md-9 ml-sm-auto col-lg-10 px-4 p-top",
                      class: {
                        "main-mini-menu": !_vm.fullMenu || !_vm.menuShow,
                        "full-menu": _vm.fullMenu,
                      },
                      attrs: { role: "main" },
                    },
                    [
                      _c("nuxt", {
                        staticClass: "body-nuxt-div",
                        class: { "mini-body": !_vm.fullMenu || !_vm.menuShow },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ]),
            _vm._v(" "),
            _c("confirm"),
            _vm._v(" "),
            _c("vue-confirm-dialog"),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }